import images from './images.json';

const POSTER_VARIANT_DESCRIPTION = {
  'type.Standard':
    '<div style="display: flex;"><div>• Starts with an individual.<br />• Includes their direct line of ancestors. (i.e. parents, grandparents, great-grandparents, etc.).<br />• Maximum number of generations for this poster is 9.</div><img src="/static/img/poster-standard.png?_" alt="" style="max-height: 100px;" /></div>',
  'type.Combination':
    '<div style="display: flex;"><div>• Starts with a couple.<br />• Includes their children, and the direct line of ancestors for each person in the starting couple.<br />• Maximum number of generations for this poster is 7.</div><img src="/static/img/poster-combination.png?_" alt="" style="max-height: 100px;" /></div>',
  'type.Descendant':
    '<div style="display: flex;"><div>• Starts with an individual or a couple.<br />• Includes their children, and the direct line of descendants up to their great-grandchildren.<br />• Maximum number of generations for this poster is 4.</div><img src="/static/img/poster-descendant.png?_" alt="" style="max-height: 100px;" /></div>',
};

/**
 * Product config
 *
 * showSkuDescription - Boolean - to show description of selected SkuProduct on ProductDetailPage
 * hideProductConfiguration - Boolean - to hide ProductConfigration component on ProductDetailPage
 * showSkuPriceStartingAt - Boolean - to show label "Starting at" before price on ProductDetailPage
 * variantDescription - object - descriptions for each Category.Value - mainly is used by reducer
 * defaultPrintOnly - Boolean - when true - bundle is not selected by default
 * hidePrintOnly - Boolean - when true - print only is not visible
 * labels - object - hash of custom labels - simply [key]: [value]
 */

const PRODUCT_SPECIFICATION = {
  'ancestry-book': {
    url: '/ancestry-book',
    reducer: [
      'productIdReducer',
      'fh-standard-hardcover_book-(.*)-(.*)',
      [
        { key: 'size', label: 'Size', index: 1 },
        { key: 'cover', label: 'Cover', index: 0 },
      ],
      {
        'leather-black': 'Black Leather',
        'leather-tan': 'Tan Leather',
        custom: 'Custom',
        '11x8': '11x8.5',
      },
      {
        availableOnly: true,
      },
    ],
    skus: [
      'fh-standard-hardcover_book-13x10-leather-black',
      'fh-standard-hardcover_book-13x10-leather-tan',
      'fh-standard-hardcover_book-13x10-custom',
      'fh-standard-hardcover_book-11x8-leather-black',
      'fh-standard-hardcover_book-11x8-leather-tan',
      'fh-standard-hardcover_book-11x8-custom',
    ],
    images: images['ancestry-book'],
    config: {
      showSkuDescription: false,
      source: "ancestry",
    },
  },

  'familysearch-book': {
    url: '/familysearch-book',
    reducer: [
      'productIdReducer',
      'fh-standard-hardcover_book-(.*)-(.*)',
      [
        { key: 'size', label: 'Size', index: 1 },
        { key: 'cover', label: 'Cover', index: 0 },
      ],
      {
        'leather-black': 'Black Leather',
        'leather-tan': 'Tan Leather',
        custom: 'Custom',
        '11x8': '11x8.5',
      },
      {
        availableOnly: true,
      },
    ],
    skus: [
      'fh-standard-hardcover_book-13x10-leather-black',
      'fh-standard-hardcover_book-13x10-leather-tan',
      'fh-standard-hardcover_book-13x10-custom',
      'fh-standard-hardcover_book-11x8-leather-black',
      'fh-standard-hardcover_book-11x8-leather-tan',
      'fh-standard-hardcover_book-11x8-custom',
    ],
    images: images['ancestry-book'],
    config: {
      showSkuDescription: false,
      source: "familysearch",
      disabled: true,
    },
  },

  'ancestry-calendar': {
    url: '/ancestry-calendar',
    skus: ['fh-calendar'],
    images: images['ancestry-calendar'],
    config: {
      source: "calendar-ancestry",
    }
  },

  'familysearch-calendar': {
    url: '/familysearch-calendar',
    skus: ['fh-calendar'],
    images: images['ancestry-calendar'],
    config: {
      source: "calendar-familysearch",
    }
  },

  'ancestry-poster': {
    url: '/ancestry-poster',
    reducer: [
      'productIdReducer',
      'fhp-(.*)-(.*)-(.*)',
      [
        { key: 'size', label: 'Size', index: 2 },
        {
          key: 'numberOfGenerations',
          label: 'Number of Generations to Show',
          index: 1,
          sort: 'asc',
        },
        { key: 'type', label: 'Poster Type', index: 0 },
      ],
      {
        '2g': '2',
        '3g': '3',
        '4g': '4',
        '5g': '5',
        '6g': '6',
        '7g': '7',
        '8g': '8',
        '9g': '9',
        std: 'Standard',
        combo: 'Combination',
        desc: 'Descendant',
      },
      {
        // unavailable: [{ 'type.Descendant': 'Coming soon' }],
        infoOnly: ['size'],
        availableOnly: true,
      },
    ],
    skus: [
      'fhp-24x18-5g-std',
      'fhp-24x18-6g-std',
      'fhp-24x36-7g-std',
      'fhp-36x48-8g-std',
      'fhp-36x48-9g-std',
      'fhp-20x16-4g-combo',
      'fhp-24x18-5g-combo',
      'fhp-36x24-6g-combo',
      'fhp-36x24-7g-combo',
      'fhp-36x24-4g-desc',
      'fhp-24x18-3g-desc',
    ],
    bundles: [
      'bundle-fhp-20x16-rails',
      'bundle-fhp-24x18-rails',
      'bundle-fhp-24x36-rails',
      'bundle-fhp-36x24-rails',
      'bundle-fhp-36x48-rails',
    ],
    images: images['ancestry-poster'],
    config: {
      variantDescription: POSTER_VARIANT_DESCRIPTION,
      defaultPrintOnly: false,
      source: "ancestry",
    },
  },

  'familysearch-poster': {
    url: '/familysearch-poster',
    reducer: [
      'productIdReducer',
      'fhp-(.*)-(.*)-(.*)',
      [
        { key: 'size', label: 'Size', index: 2 },
        {
          key: 'numberOfGenerations',
          label: 'Number of Generations to Show',
          index: 1,
          sort: 'asc',
        },
        { key: 'type', label: 'Poster Type', index: 0 },
      ],
      {
        '2g': '2',
        '3g': '3',
        '4g': '4',
        '5g': '5',
        '6g': '6',
        '7g': '7',
        '8g': '8',
        '9g': '9',
        std: 'Standard',
        combo: 'Combination',
        desc: 'Descendant',
      },
      {
        // unavailable: [{ 'type.Descendant': 'Coming soon' }],
        infoOnly: ['size'],
        availableOnly: true,
      },
    ],
    skus: [
      'fhp-24x18-5g-std',
      'fhp-24x18-6g-std',
      'fhp-24x36-7g-std',
      'fhp-36x48-8g-std',
      'fhp-36x48-9g-std',
      'fhp-20x16-4g-combo',
      'fhp-24x18-5g-combo',
      'fhp-36x24-6g-combo',
      'fhp-36x24-7g-combo',
      'fhp-36x24-4g-desc',
      'fhp-24x18-3g-desc',
    ],
    bundles: [
      'bundle-fhp-20x16-rails',
      'bundle-fhp-24x18-rails',
      'bundle-fhp-24x36-rails',
      'bundle-fhp-36x24-rails',
      'bundle-fhp-36x48-rails',
    ],
    images: images['ancestry-poster'],
    config: {
      variantDescription: POSTER_VARIANT_DESCRIPTION,
      defaultPrintOnly: false,
      source: "familysearch",
    },
  },

  'premium-hardcover-books': {
    url: '/premium-hardcover-books',
    reducer: [
      'productIdReducer',
      'book-(.*)-hardcover-(.*)',
      [
        { key: 'size', label: 'Size' },
        { key: 'cover', label: 'Cover' },
      ],
      {
        'leather-black': 'Leather Black',
        'leather-tan': 'Leather Tan',
        // 'linen-gray': 'Linen Gray',
        // 'linen-black': 'Linen Black',
        // 'linen-cream': 'Linen Cream',
        custom: 'Custom',
        '11x8': '11x8.5”',
        '13x10': '13x10”',
      },
      {
        availableOnly: true,
      },
    ],
    skus: [
      'book-11x8-hardcover-custom',
      // 'book-11x8-hardcover-linen-gray',
      // 'book-11x8-hardcover-linen-black',
      // 'book-11x8-hardcover-linen-cream',
      'book-11x8-hardcover-leather-black',
      'book-11x8-hardcover-leather-tan',
      'book-13x10-hardcover-custom',
      // 'book-13x10-hardcover-linen-gray',
      // 'book-13x10-hardcover-linen-black',
      // 'book-13x10-hardcover-linen-cream',
      'book-13x10-hardcover-leather-black',
      'book-13x10-hardcover-leather-tan',
    ],
    images: images['premium-hardcover-books'],
  },

  'custom-books': {
    url: '/custom-books',
    reducer: [
      'productIdReducer',
      'book-8x8-(.*)-custom',
      [{ key: 'type', label: 'Type' }],
      {},
      {
        availableOnly: true,
      },
    ],
    skus: ['book-8x8-hardcover-custom', 'book-8x8-softcover-custom'],
    images: images['softcover-books'],
  },

  'custom-layflats': {
    url: '/custom-layflats',
    reducer: [
      'productIdReducer',
      'book-(.*)-layflat-custom',
      [{ key: 'size', label: 'Size' }],
      {
        '8x8': '8x8”',
        '11x8': '11x8.5”',
      },
      {
        availableOnly: true,
      },
    ],
    skus: ['book-8x8-layflat-custom', 'book-11x8-layflat-custom'],
    images: images['hardcover-book'],
  },

  'family-tree-book': {
    url: '/family-tree-book',
    name: 'Family Tree Book', // REMOVE
    reducer: ['configReducer', []],
    skus: [
      'fh-standard-hardcover_book-13x10-leather-black',
      'fh-standard-hardcover_book-13x10-leather-tan',
      'fh-standard-hardcover_book-13x10-custom',
      'fh-standard-hardcover_book-11x8-leather-black',
      'fh-standard-hardcover_book-11x8-leather-tan',
      'fh-standard-hardcover_book-11x8-custom',
    ],
    images: images['ancestry-book'],
    config: {
      showSkuDescription: false,
      showSkuPriceStartingAt: true,
      continueButtonUrl: '/editor/tree',
      editorReducer: [
        'productIdReducer',
        'fh-standard-hardcover_book-(.*)-(.*)',
        [
          { key: 'size', label: 'Size', index: 1 },
          { key: 'cover', label: 'Cover', index: 0 },
        ],
        {
          'leather-black': 'Black Leather',
          'leather-tan': 'Tan Leather',
          custom: 'Custom',
          '11x8': '11x8.5',
        },
        {
          availableOnly: true,
        },
      ],
    },
  },

  'family-tree-poster': {
    url: '/family-tree-poster',
    reducer: ['configReducer', []],
    // reducer: [
    //   'configReducer',
    //   [
    //     {
    //       key: 'type',
    //       label: 'Poster Type',
    //       values: [
    //         'std',
    //         'combo',
    //         // 'desc'
    //       ],
    //     },
    //   ],
    //   {
    //     std: 'Standard',
    //     combo: 'Combination',
    //     desc: 'Descendant',
    //   },
    //   {
    //     unavailable: [{ 'type.Descendant': 'Coming soon' }],
    //   },
    // ],
    skus: [
      'fhp-24x18-5g-std',
      'fhp-24x18-6g-std',
      'fhp-24x36-7g-std',
      'fhp-36x48-8g-std',
      'fhp-36x48-9g-std',
      'fhp-20x16-4g-combo',
      'fhp-24x18-5g-combo',
      'fhp-36x24-6g-combo',
      'fhp-36x24-7g-combo',
      'fhp-36x24-4g-desc',
      'fhp-24x18-3g-desc',
    ],
    images: images['ancestry-poster'],
    config: {
      source: "mycanvas",
      showSkuPriceStartingAt: true,
      continueButtonUrl: '/editor/tree',
      variantDescription: POSTER_VARIANT_DESCRIPTION,
      editorReducer: [
        'productIdReducer',
        'fhp-(.*)-(.*)-(.*)',
        [
          { key: 'size', label: 'Size', index: 2 },
          {
            key: 'numberOfGenerations',
            label: 'Number of Generations to Show',
            index: 1,
            sort: 'asc',
          },
          { key: 'type', label: 'Poster Type', index: 0 },
        ],
        {
          '2g': '2',
          '3g': '3',
          '4g': '4',
          '5g': '5',
          '6g': '6',
          '7g': '7',
          '8g': '8',
          '9g': '9',
          std: 'Standard',
          combo: 'Combination',
          desc: 'Descendant',
        },
        {
          // unavailable: [{ 'type.Descendant': 'Coming soon' }],
          infoOnly: ['size'],
          availableOnly: true,
        },
      ],
    },
  },

  artprint: {
    url: '/artprint',
    skus: ['artprint-8x10', 'artprint-11x14', 'artprint-small', 'artprint-large', 'artprint-20x24'],
    bundles: [
      'bundle-artprint-11x14',
      'bundle-artprint-small',
      'bundle-artprint-large',
      'bundle-artprint-20-24',
    ],
    images: images.artprint,
    config: { defaultPrintOnly: true },
  },

  'engineer-prints': {
    url: '/engineer-prints',
    skus: ['engineer-print'],
    images: images['engineer-prints'],
  },

  'framed-art-prints': {
    url: '/framed-art-prints',
    reducer: [
      'productIdReducer',
      'framedprint-(.*)-(.*)-black',
      ['Frame Size', 'Print Size'],
      {
        // hack - f_ has to have "×" this char in ALIAS !!!
        f_11x14: '11×14”',
        f_16x20: '16×20”',
        f_20x30: '20×30”',
        // hack - p_ has to have "x" this char in ALIAS !!!
        p_8x10: '8x10”',
        p_11x14: '11x14”',
        p_12x18: '12x18”',
        p_16x20: '16x20”',
        p_20x30: '20x30”',
      },
      {
        availableOnly: true,
      },
    ],
    skus: [
      'framedprint-f_11x14-p_8x10-black',
      'framedprint-f_11x14-p_11x14-black',
      'framedprint-f_16x20-p_11x14-black',
      'framedprint-f_16x20-p_12x18-black',
      'framedprint-f_16x20-p_16x20-black',
      'framedprint-f_20x30-p_20x30-black',
    ],
    images: images.framedprints,
    config: { showSkuDescription: true },
  },

  // 'desktop-calendar': {
  //   url: '/desktop-calendar',
  //   skus: ['desktop-calendar'],
  //   images: images['desktop-calendar'],
  // },

  giftcard: {
    url: '/giftcard',
    skus: ['giftcard-10', 'giftcard-25', 'giftcard-50', 'giftcard-75', 'giftcard-100'],
    images: images['giftcard-mc'],
  },

  'good-hangups': {
    url: '/good-hangups',
    skus: ['good-hangups'],
    images: images['good-hangups'],
  },

  'hardcover-book': {
    url: '/hardcover-book',
    skus: ['photolane-hardcover-photo-book'],
    images: images['hardcover-book'],
  },

  'metal-desk-prints': {
    url: '/metal-desk-prints',
    reducer: ['productIdReducer', 'metal-print-(.*)-desk', ['Size']],
    skus: [
      'metal-print-4x4-desk',
      'metal-print-4x6-desk',
      'metal-print-5x5-desk',
      'metal-print-5x7-desk',
      'metal-print-8x10-desk',
    ],
    images: images['metal-desk-prints'],
  },

  'metal-wall-prints': {
    url: '/metal-wall-prints',
    reducer: ['productIdReducer', 'metal-print-(.*)', ['Size']],
    skus: [
      'metal-print-8x10',
      'metal-print-11x14',
      'metal-print-12x12',
      'metal-print-12x18',
      'metal-print-16x20',
      'metal-print-16x24',
      'metal-print-20x30',
      'metal-print-24x36',
    ],
    images: images['metal-wall-prints'],
  },

  'skeleton-clips': {
    url: '/skeleton-clips',
    skus: ['skeleton-clip-large'],
    images: images['skeleton-clips'],
  },

  'softcover-books': {
    url: '/softcover-books',
    skus: ['softcover-photo-book', 'photolane-softcover-photo-book'],
    images: images['softcover-books'],
  },

  'wall-calendar': {
    url: '/wall-calendar',
    skus: ['wall-calendar'],
    images: images['wall-calendar'],
  },

  'wall-calendar-large': {
    url: '/wall-calendar-large',
    skus: ['wall-calendar-large'],
    images: images['wall-calendar-large'],
  },

  'wooden-rails': {
    url: '/wooden-rails',
    reducer: [
      'productIdReducer',
      'wooden-rail-(.*)-(.*)',
      [
        { key: 'size', label: 'Size' },
        { key: 'color', label: 'Color' },
      ],
      {
        12: '12”',
        14: '14”',
        16: '16”',
        17: '17”',
        20: '20”',
        24: '24”',
        36: '36”',
        48: '48”',
      },
      {
        availableOnly: true,
      },
    ],
    skus: [
      'wooden-rail-12-black',
      'wooden-rail-12-maple',
      'wooden-rail-12-oak',
      'wooden-rail-14-black',
      'wooden-rail-14-maple',
      'wooden-rail-14-oak',
      'wooden-rail-16-black',
      'wooden-rail-16-maple',
      'wooden-rail-16-oak',
      'wooden-rail-17-black',
      'wooden-rail-17-maple',
      'wooden-rail-17-oak',
      'wooden-rail-20-black',
      'wooden-rail-20-maple',
      'wooden-rail-20-oak',
      'wooden-rail-24-black',
      'wooden-rail-24-maple',
      'wooden-rail-24-oak',
      'wooden-rail-36-black',
      'wooden-rail-36-maple',
      'wooden-rail-36-oak',
      'wooden-rail-48-black',
      'wooden-rail-48-maple',
      'wooden-rail-48-oak',
    ],
    images: images['wooden-rails'],
  },

  'wrapped-canvas-prints': {
    url: '/wrapped-canvas-prints',
    reducer: ['productIdReducer', 'gallery-wrapped-canvas-(.*)', ['Size']],
    skus: [
      'gallery-wrapped-canvas-8x8',
      'gallery-wrapped-canvas-8x10',
      'gallery-wrapped-canvas-11x14',
      'gallery-wrapped-canvas-12x12',
      'gallery-wrapped-canvas-12x36',
      'gallery-wrapped-canvas-16x16',
      'gallery-wrapped-canvas-16x20',
      'gallery-wrapped-canvas-16x24',
      'gallery-wrapped-canvas-20x24',
      'gallery-wrapped-canvas-20x30',
      'gallery-wrapped-canvas-20x60',
      'gallery-wrapped-canvas-24x36',
      'gallery-wrapped-canvas-30x40',
      'gallery-wrapped-canvas-36x36',
    ],
    images: images['wrapped-canvas-prints'],
  },

  'acrylic-prints': {
    url: '/acrylic-prints',
    reducer: ['productIdReducer', 'acrylic-print-(.*)', ['Size']],
    skus: [
      'acrylic-print-8x10',
      'acrylic-print-11x14',
      'acrylic-print-12x12',
      'acrylic-print-12x18',
      'acrylic-print-16x20',
      'acrylic-print-16x24',
      'acrylic-print-20x20',
      'acrylic-print-20x30',
      'acrylic-print-24x36',
      'acrylic-print-30x40',
    ],
    images: images['acrylic-wallprint'],
  },

  'acrylic-magnets': {
    url: '/acrylic-magnets',
    skus: [
      'acrylic-magnet-square-small',
    ],
    images: images['acrylic-magnet'],
  },

  'photobooth-magnets': {
    url: '/photobooth-magnets',
    skus: [
      'photobooth-magnet-1',
      'photobooth-magnet-2',
      'photobooth-magnet-4',
    ],
    images: images['photobooth-magnet']
  },

  'pexeso': {
    url: '/pexeso',
    skus: ['pexeso'],
    images: images['square-prints'],
  },
};

export default PRODUCT_SPECIFICATION;


